'use strict';

/** 注册方法polyfill */
const registerPolyfill = () => {
  const files = require.context('@/utils/polyfill/modules', true, /es.*?\.js$/);
  files.keys().forEach((key) => {
    const { target, property, proto, handler } = files(key);
    const targetObject = proto ? target['prototype'] : target;
    if (targetObject[property]) {
      return;
    }
    targetObject[property] = handler;
  });
};

registerPolyfill();
